import { render, staticRenderFns } from "./ValidationsPage.vue?vue&type=template&id=5c260875&scoped=true"
import script from "./ValidationsPage.vue?vue&type=script&lang=js"
export * from "./ValidationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c260875",
  null
  
)

export default component.exports